import { useMemo } from 'react';

const getT = (isDark) => ({
  // Backgrounds
  pageBg: isDark ? '#0b0b14' : '#f0f2f5',
  headerBg: isDark ? 'rgba(15,15,26,0.98)' : '#ffffff',
  cardBg: isDark ? 'rgba(255,255,255,0.07)' : '#ffffff',
  cardHoverBg: isDark ? 'rgba(255,255,255,0.10)' : '#fafbff',
  cardActiveBg: isDark ? 'rgba(255,255,255,0.11)' : '#fafaff',
  customizeBg: isDark ? 'rgba(0,0,0,0.3)' : '#f8fafc',
  footerBg: isDark ? 'rgba(0,0,0,0.35)' : '#ffffff',
  recBg: isDark ? 'rgba(251,191,36,0.08)' : 'rgba(251,191,36,0.07)',
  recBorder: isDark ? 'rgba(251,191,36,0.2)' : 'rgba(251,191,36,0.3)',
  tabActiveBg: isDark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.05)',
  pillBg: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',

  // Borders
  borderMain: isDark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.08)',
  borderCard: isDark ? 'rgba(255,255,255,0.14)' : 'rgba(0,0,0,0.12)',
  borderHover: isDark ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.18)',

  // Text
  textPrimary: isDark ? 'rgba(255,255,255,0.92)' : '#0f172a',
  textSecondary: isDark ? 'rgba(255,255,255,0.55)' : '#475569',
  textMuted: isDark ? 'rgba(255,255,255,0.30)' : '#94a3b8',
  textTab: isDark ? 'rgba(255,255,255,0.40)' : '#94a3b8',
  textDesc: isDark ? 'rgba(255,255,255,0.38)' : '#64748b',

  // Shadows
  cardShadow: isDark ? '0 2px 12px rgba(0,0,0,0.45), 0 1px 3px rgba(0,0,0,0.25)' : '0 1px 4px rgba(0,0,0,0.07), 0 4px 16px rgba(0,0,0,0.05)',
  hoverShadow: isDark ? '0 16px 48px rgba(0,0,0,0.5)' : '0 12px 40px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.06)',
  previewShadow: isDark ? '0 4px 20px rgba(0,0,0,0.4)' : '0 2px 12px rgba(0,0,0,0.12)',

  // Customize
  inputBg: isDark ? 'rgba(255,255,255,0.06)' : '#f1f5f9',
  inputBorder: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
  inputColor: isDark ? 'rgba(255,255,255,0.85)' : '#0f172a',

  isDark,
});

export default function useGalleryTheme(isDark) {
  return useMemo(() => getT(isDark), [isDark]);
}
